import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import './LoginCard.css';
import MessageCard from '../message-card/MessageCard';
import { authConfig } from '../AuthConfig';
import StudentInfo from '../student_info/info';

const LoginCard = () => {
    const { isAuthenticated, loginWithRedirect, logout, getAccessTokenSilently, isLoading, user } = useAuth0();
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [unauthorized, setUnauthorized] = useState(false);
    const [showMessageCard, setShowMessageCard] = useState(true);
    const [initialCheckComplete, setInitialCheckComplete] = useState(false);
    const [token, setToken] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            if (isAuthenticated) {
                try {
                    // Get the token from Auth0
                    const newToken = 'Bearer ' + await getAccessTokenSilently();
                    setToken(newToken);

                    // Send the token to your backend
                    const response = await fetch('https://7m6qc50xjh.execute-api.ap-south-1.amazonaws.com/api/marks', {
                    //const response = await fetch('http://localhost:3000/api/marks', {
                        headers: {
                            'Authorization': newToken
                        },
                        credentials: 'include'
                    });

                    if (response.status === 403) {
                        setUnauthorized(true);
                        return;
                    }

                    if (!response.ok) {
                        if (response.status === 500)
                            throw new Error('Error occured at server');
                        else
                            throw new Error("Server didn't respond. Status: ", response.status);
                    }

                    const responseData = await response.json();
                    setData(responseData);
                } catch (err) {
                    setError(err.message);
                }
            }
            setInitialCheckComplete(true);
        };
        fetchData();
    }, [isAuthenticated, getAccessTokenSilently]);

    const handleCardClose = () => {
        setShowMessageCard(false);
    };

    if (error) {
        return (
            <div>                    
                <div className="card">
                    <div className="card-content">
                        <p>Welcome back {user.name}!</p>
                        <button onClick={() => logout({ returnTo: authConfig.returnto })}>Log Out</button>
                    </div>
                </div>
                {showMessageCard && <MessageCard message={error} onClose={handleCardClose} isError={true} />}
            </div>
        );
    }

    if (isLoading) {
        <div>Loading authentication state...</div>;
        return (
            <div> 
                {showMessageCard && <MessageCard message={"Please wait, your details are being checked. "} onClose={handleCardClose} isError={false} />}
            </div>
        );
    }

    if (!initialCheckComplete) {
        return null; // or some loading state if you prefer
    }
    
    if (isAuthenticated) {
        if (unauthorized) {
            return (
                <div>                    
                    <div className="card">
                        <div className="card-content">
                            <p>Welcome back {user.name}!</p>
                            <button onClick={() => logout({ returnTo: authConfig.returnto })}>Log Out</button>
                        </div>
                    </div>
                    {showMessageCard && <MessageCard message={"You are not authorized to view these recources. "} onClose={handleCardClose} isError={true} />}
                </div>            
            );
        }

        if (!data) {
            return (
                <div> 
                    {showMessageCard && <MessageCard message={"Please wait, your marks and other details are being loaded. "} onClose={handleCardClose} isError={false} />}
                </div>
            );
        }

        return (
            <div>
                <div className="card">
                    <div className="card-content">
                        <p>Welcome back {user.name}! </p>
                        <button onClick={() => logout({ returnTo: authConfig.returnto })}>Log Out</button>
                    </div>
                </div>
                <div>
                    <StudentInfo data={data} token={token} />
                </div>
            </div>
        );
    }

    return (
        <div className="card">
            <div className="card-content">
                <p>You must be logged in to view your marks and other details.</p>
                <button onClick={() => loginWithRedirect()}>Log In</button>
            </div>
        </div>
    );
};

export default LoginCard;
